import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { MessageCircle } from "lucide-react";
import { ChatPanel } from "./ChatPanel";

interface ChatBubbleProps {
  assessmentId: string;
  cardContextLabel?: string;
  cardContextData?: string;
}

export function ChatBubble({ assessmentId, cardContextLabel, cardContextData }: ChatBubbleProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        className="fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-lg z-50"
        onClick={() => setOpen(true)}
        size="icon"
        title={"Open AI Assistant"}
      >
        <MessageCircle className="h-6 w-6" />
      </Button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side="right"
          className="p-0 w-[min(900px,95vw)] flex flex-col"
          style={{ height: "100vh" }}
        >
          <SheetHeader className="sr-only">
            <SheetTitle>{"AI Assistant"}</SheetTitle>
            <SheetDescription>{"ESG sustainability reporting assistant"}</SheetDescription>
          </SheetHeader>
          <ChatPanel
            assessmentId={assessmentId}
            cardContextLabel={cardContextLabel}
            cardContextData={cardContextData}
            onClose={() => setOpen(false)}
          />
        </SheetContent>
      </Sheet>
    </>
  );
}
